export enum MyListingsFilters {
  ALL = 1,
  SPECIALTY = 2,
  VACANCY = 3,
}
